import gql from 'graphql-tag';

export const changeStatus = gql`
  mutation changeStatus($id: Int!){
    changeStatus( id: $id ){
      id
    }
  }
`;
